import * as RxFactory from './api/rx-factory'
import * as Enpoints from './api/endpoints'
export function _executeApi(apiLink, credentials, getToken, commit, callback) {
    try {
        let response_array = []
        if (credentials.localParams.type == 'form') { credentials.globalParams = credentials.globalParams.form }
        if (getToken == '') { getToken = '' }
        credentials.localParams.parameter.pageLoader = true
        if(credentials.localParams.link){
            RxFactory.get(Enpoints.BASE_URL + apiLink, credentials.globalParams, getToken)
                .map(response => response.data)
                .subscribe(data => {
                        credentials.localParams.parameter.pageLoader = false
                        callback(false, data);
                    },
                    e => { console.log(e); _handleErrorResponse(e, commit); })
        }else{
            RxFactory.post(Enpoints.BASE_URL + apiLink, credentials.globalParams, getToken)
                .map(response => response.data)
                .subscribe(data => {
                    credentials.localParams.parameter.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            response_array.res_data = data.data
                            if (data.msg) {
                                response_array.msg = data.msg
                            }
                            callback(false, response_array)
                        } else {
                            if ('status' in data && data.status == 401) {
                                credentials.localParams.parameter.$root.$children[0].walletSessionTimeOut = true
                                // callback(true, response_array)
                            } else {
                                if (typeof data.msg == 'object') {
                                    response_array.res_data = data.msg.msg
                                    response_array['code'] = data.msg.code
                                } else {
                                    response_array.res_data = data.msg
                                    response_array['code'] = data.code
                                }
                                callback(true, response_array)
                            }
                        }
                    }
                },
                e => { _handleErrorResponse(e, commit) })
        }
    } catch (ex) { _handleErrorResponse(ex, commit) }
}

export function _messageDisplayFunction(getParameter, getMessage, msgType) {
    //getParameter.response_msg = getMessage
    //getParameter.msg_type = msgType
    getParameter.$notify({
        group: 'foo',
        type: msgType,
        text: getMessage,
        duration: 10000,
        closeOnClick: true
    });
    try {
        getParameter.notification_msg = getMessage;
        getParameter.notification_type = msgType;

        setTimeout(function () {
            getParameter.notification_msg = '';
            getParameter.notification_type = '';
        }, 10000);
    } catch (e) { }
}

export function _cleanUp(commit, msg, status, loaderId) {
    let loaderArr = (typeof loaderId !== 'undefined') ? [loaderId] : []
    commit("SET_INFO", msg)
}

export function _handleErrorResponse(e, commit) {
    let response = { info: 'NOK', msg: 'Service not available' }
    if (typeof e.response === 'undefined') {
        try {
            const statusCheck = e.toString().toLowerCase()
            if (statusCheck.indexOf('network') > -1) {
                response = { info: 'NOK', msg: 'Network Error' }
            }
        } catch (e) { }
    } else {
        response = e.response.data
    }
    _cleanUp(commit, response, response.status)
    if (typeof e.response !== 'undefined') {
        if (e.response.status == 401) {
            let data = {}
            let options = {}
            options.forward = true
            _handleLogout(data, commit, options)
        }
    }
}

export function _handleLogout(data, commit, options) {
    const router = options.router
    let user = {}
    localStorage.clear();
    if ('msg' in data && 'info' in data) {
        _cleanUp(commit, data.msg, data.info)
    }
    if (options.forward === true) {
        window.location.replace("/")
    }
}

export function formatPriceCommon(price, isCrypto) {
    if (typeof price != 'number')
        price = parseFloat(price)
    if (isNaN(price))
        return 0
    price = price.toFixed(isCrypto ? 8 : 2)
    // return price.replace(/([0-9]+(\.[0-9]+[1-9])?)(\.?0+$)/, '$1')
    let stringPrice = parseInt(price).toLocaleString() + ((price.toString().indexOf('.') != -1) ? ('.' + price.split('.')[1]) : '')
    if (isCrypto) {
        return stringPrice.replace(/(?:(\.\d*?[1-9]+)|\.)0*$/gm, '$1')
    } else {
        return stringPrice
    }
}


// WEBPACK FOOTER //
// ./src/store/commomFunction.js